import React, { Component } from "react";
import PropTypes from "prop-types";
import { css } from "emotion";
/*eslint no-console: 0*/

const labelStyles = css`
  float: left;
  margin: 0 0.5em 0 0;
`;

export default class DropdownBox extends Component {
  static propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        //The value passed back with onIDSelected
        value: PropTypes.any.isRequired,
        //The text used to represent the value in the list
        text: PropTypes.string.isRequired
      })
    ),
    label: PropTypes.string,
    //How many options shown at once
    size: PropTypes.number,
    //Value corresponding to an ID
    pleaseSelectOption: PropTypes.bool,
    pleaseSelectText: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  };

  static defaultProps = {
    pleaseSelectOption: false,
    pleaseSelectText: "Please select",
    size: 1
  };

  //Options are given a unique value.
  optionList = () => {
    let options = this.props.pleaseSelectOption
      ? [
        <option key={"PS"} value={"PS"}>
            {this.props.pleaseSelectText}
          </option>
      ]
      : [];
    return options.concat(
      this.props.options.map(({ value, text }, index) => {
        return (
          <option key={index} value={index.toString()}>
            {text}
          </option>
        );
      })
    );
  };

  onChange = event => {
    let val = event.target.value;
    if (val === "PS") {
      this.props.onChange(undefined);
    } else {
      this.props.onChange(this.props.options[parseInt(val)].value);
    }
  };

  render = () => {
    let classNames = ["dropdown-box"];
    if (this.props.className) classNames.push(this.props.className);
    return (
      <label>
        <span className={`upn-component-dropdownBox__label ${labelStyles}`}>
          {this.props.label}
        </span>
        <select
          className={classNames.join(" ")}
          onChange={this.onChange}
          size={this.props.size}
          //options ID is mapped to an option value.
          value={
            this.props.value === undefined
              ? "PS"
              : this.props.options.findIndex(
                  ({ value }) => value === this.props.value
                )
          }
        >
          {this.optionList()}
        </select>
      </label>
    );
  };
}
